<div class="pa-bulk-actions-bar" [class.pa-bulk-actions-bar_mobile]="isMobile">
  <div class="pa-bulk-actions-bar__inner">
    <!-- Левая часть -->
    <div class="pa-bulk-actions-bar__left">
      <pa-button
        class="pa-bulk-actions-bar__close"
        severity="secondary"
        variant="text"
        size="small"
        [icon]="'pi pi-times'"
        (click)="handleClose()"
      >
      </pa-button>

      <pa-button
        *ngIf="showSelectAll && selectedCount > 0 && !isAllSelected"
        class="pa-bulk-actions-bar__select-all"
        severity="secondary"
        [label]="isMobile ? undefined : 'Выбрать всё'"
        variant="text"
        size="small"
        [icon]="'pi pi-list-check'"
        (click)="handleSelectAll()"
      >
      </pa-button>

      <span class="pa-bulk-actions-bar__counter">
        {{ selectedLabel }} {{ selectedCount }}
      </span>
    </div>

    <!-- Вертикальный разделитель (только для десктопа) -->
    <div
      class="pa-bulk-actions-bar__divider"
      *ngIf="hasActions && !isMobile"
    ></div>

    <!-- Правая часть: действия -->
    <div class="pa-bulk-actions-bar__right" *ngIf="hasActions">
      <!-- ПК: отдельные кнопки действий -->
      <ng-container *ngIf="!isMobile; else mobileMenu">
        <pa-button
          *ngFor="let action of actions"
          class="pa-bulk-actions-bar__action"
          severity="secondary"
          variant="text"
          size="small"
          [icon]="action.icon"
          [label]="action.label"
          [disabled]="action.disabled ? action.disabled() : false"
          (click)="handleActionClick(action)"
        >
        </pa-button>
      </ng-container>

      <!-- Мобила: троеточие с меню действий -->
      <ng-template #mobileMenu>
        <pa-context-menu
          [items]="mobileMenuItems"
          [rowContext]="null"
          icon="pi pi-ellipsis-v"
          variant="text"
        >
        </pa-context-menu>
      </ng-template>
    </div>
  </div>
</div>

